﻿import * as React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import './Footer.css';

export default class Footer extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <Container className="footer" fluid>
                <Row className="footer-detail">
                    <Col className="column" md="4" sm="12">
                        <h3>Contact Us</h3>
                        <div>Toll Free: <a href="tel:16026896045">(602) 689-6045</a></div>
                        <div>Email: <a href="mailto:info@premierpressurewash.com">info@premierpressurewash.com</a></div>
                        <div className="social-icons">
                            <a className="social-icon" target="_blank" href="https://www.facebook.com/premierpressurewash/"><img src="../img/social-meta.png"></img></a>
                            <a className="social-icon" target="_blank" href="https://www.youtube.com/channel/UCg9t-8r81jIHNETxtz8cBmg"><img src="../img/social-youtube.png"></img></a>
                            <a className="social-icon" target="_blank" href="https://www.instagram.com/premier_pressure_wash/"><img src="../img/social-instagram.png"></img></a>
                        </div>
                    </Col>
                    <Col className="column" md="4" sm="12">
                        <h3>Company</h3>
                        <div><a href="/about">About Us</a></div>
                        <div><a href="/job-opportunities">Career</a></div>
                        <div><a href="/privacy">Privacy Policy</a></div>
                    </Col>
                    <Col className="column" md="4" sm="12">
                        <h3>Get Free Estimate</h3>
                        <h4><a href="tel:16026896045">(602) 689-6045</a></h4>
                        <p>It&apos;s quick and easy. Call to get a free estimate.</p>
                        <Button color="primary" href="/contact-us" >Contact Us Online</Button>
                    </Col>
                </Row>
                <Row className="footer-accreditation">
                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                        <a className="logo" href="https://www.bbb.org/us/az/scottsdale/profile/pressure-washing/premier-pressure-washing-window-cleaning-1126-1000044520" target="_blank"><img src="../img/bbb-logo.png"></img></a>
                        <h3>A+ Rating From Better Business Bureau &reg;</h3>
                    </Col>
                </Row>
                <Row className="footer-credit">
                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                        <p>&copy; 2022 Premier Pressure by Innovation Software Consulting Firm</p>
                    </Col>
                </Row>
            </Container>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}